import React, { FC, useContext } from "react";
import { PaginationModel } from "../../models/Pagination";
import { ContextToggle } from "./ContextToggle";
import { DEF_PG_SIZE_LIST_W_ADD } from '../../constants/maximum-page-size';

export interface PaginationContextValueType extends ContextToggle {
    pagination: PaginationModel;
    updatePageNumber: (pageNumber: number) => void;
    updatePageSize: (pageSize: number) => void;
}

export const emptyPaginationContextValue = {
    isInUse: false,
    pagination: {
        maxPageSize: DEF_PG_SIZE_LIST_W_ADD,
        pageNumber: 1,
        totalCount: 0,
        totalPages: 1,
        sizes: [DEF_PG_SIZE_LIST_W_ADD, 50, 100],
        pages: [1]
    },
    updatePageNumber: () => { },
    updatePageSize: () => { },
};

export const PaginationContext = React.createContext<PaginationContextValueType>(emptyPaginationContextValue);

export const usePagination = () => {
    return useContext(PaginationContext);
};
